import React, { useState } from 'react';
import { mergeRestaurantExempleProps } from '../../utils/restaurantExempleDefaults';
import {
  MAIN_VARIANTS,
  RestaurantBlock,
  RestaurantChromeBlock,
  RestaurantFooterBlock,
  useRestaurantContext,
} from './RestaurantExempleBlocks';
import './RestaurantExemple.css';

export default function RestaurantExempleView({
  props: rawProps,
  site,
  slug,
  interactive = true,
  commandeUrl,
}) {
  const p = mergeRestaurantExempleProps(rawProps);
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = () => setNavOpen(false);
  const baseCtx = useRestaurantContext(p, { site, slug, interactive, commandeUrl });
  const ctx = {
    ...baseCtx,
    navOpen,
    setNavOpen,
    closeNav,
    site,
  };

  return (
    <div className="restaurant-exemple">
      <RestaurantChromeBlock p={p} ctx={ctx} />
      <main>
        {MAIN_VARIANTS.map((variant) => (
          <RestaurantBlock key={variant} variant={variant} p={p} ctx={ctx} />
        ))}
      </main>
      <RestaurantFooterBlock p={p} ctx={ctx} />
    </div>
  );
}
